
























































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  GetBindingLaboratoryCategoriesList,
  GetLaboratoryCategoriesList,
  DeleteLaboratoryCategories
} from "@/api/laboratoryCategories";
import bindingLaboratoryCategories from "./bindingLaboratoryCategories.vue";
import saveLaboratoryCategories from "./saveLaboratoryCategories.vue";
@Component({
  components: {bindingLaboratoryCategories,saveLaboratoryCategories },
})
export default class extends AbpBase {
    cateData: any = [];//大类数据
    itemData: any = [];//化验指标数据
    cateLoading: boolean = false;//大类加载
    itemLoading: boolean = false;//化验指标加载
    categories: any = null; //当前选中的指标
    adjustItemData: any; //调整的指标
    adjustItemShow: boolean = false;//调整指标页面
    showLaboratoryCategories: boolean = false;//修改大类页面
    laboratoryCategoriesData:any={};
    queryString="";
    title="";
    //化验指标标题
    cateColumns = [
        {
            title: "大类名称",
            key: "largeCategoryName",
            minWidth: 120,
        },
        {
            title: "排序码",
            key: "sortNum",
            width: 120,
        },
        {
            title: "操作",
            width: 180,
            render: (h1: any, params: any) => {
                const h = this.$createElement;
                let isdefaultDom: any;
                return h("div", [
                    isdefaultDom,
                    h(
                        "Button",
                        {
                        props: {
                            type: "primary",
                            size: "small",
                        },
                        style: {
                            marginRight: "15px",
                        },
                        on: {
                            click: () => {
                                this.editData(params.row);
                            },
                        },
                        },
                        "编辑"
                    ),
                    h(
                        "Button",
                        {
                        props: { type: "error", size: "small" },
                        on: {
                            click: () => {
                                this.delData(params.row);
                            },
                        },
                        },
                        "删除"
                    ),
                ]);
            },
        },
    ];
    //绑定指标标题
    itemColumns = [
         {
            title: "指标编码",
            key: "itemCode",
            minWidth: 120,
        },
        {
            title: "指标名称",
            key: "itemName",
            minWidth: 120,
        },
        {
            title: "单位",
            key: "unit",
            width: 80,
        },
        {
            title: "样本",
            key: "sampleClass",
            minWidth: 80,
        },
        {
            title: "最大值",
            key: "maximum",
            width: 120,
        },
        {
            title: "最小值",
            key: "minimum",
            width: 120,
        },
        {
            title: "排序码",
            key: "sortNum",
            width: 120,
        },
    ];
    created() 
    {
        this.getCateList();
    }
    refreshData()
    {
        this.getCateList();
    }
    handleCateClick(row: any) {
        this.categories = row;
        this.title = row.largeCategoryName;
        this.getItemList();
    }
    async getItemList() {
        if (!this.categories) {
            return;
        }
        this.itemLoading = true;
        let res = await GetBindingLaboratoryCategoriesList({
            categoriesId: this.categories.id,
        });
        this.itemLoading = false;
        this.itemData = res.objects;
    }
    async getCateList() {
        this.cateLoading = true;
        this.cateData=[];
        this.categories={};
        let res = await GetLaboratoryCategoriesList({queryString:this.queryString });
        this.cateLoading = false;
        this.cateData = res.objects;
    }
    adjustItem() {
        if (!this.categories) {
        return;
        }
        this.adjustItemData = {
        mode: "add",
        categoriesId: this.categories.id,
        largeCategoryName: this.categories.largeCategoryName,
        };
        this.adjustItemShow = true;
    }
    async delData(row: any) {
        this.$Modal.confirm({
            title: "提示",
            content: "此操作将永久删除该化验大类, 是否继续?",
            onOk: async () => {
                let res = await DeleteLaboratoryCategories({ Id: row.Id });
                this.getCateList();
            },
        });
    }
    editData(row: any) {
        this.laboratoryCategoriesData= row;
        this.laboratoryCategoriesData.title = "编辑";
        this.showLaboratoryCategories=true;
    }
    addData() {
        this.laboratoryCategoriesData={
            title:"新增"
        };
        this.showLaboratoryCategories = true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/laboratoryCategories/laboratoryCategories.vue